import {Avatar, Chip, Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useState} from "react";
import {getFileUrl} from "../../../config";
import {BsCheck, BsHourglassSplit, BsX} from "react-icons/bs";
import {TableHead} from "../../system/thead";


const TABLE_HEAD = ["#", "کاربر", "پروفایل", "مبلغ", "مرجع", "وضعیت", "شروع از", "زمان"];

export function PaymentReportGrid({paymentReport, setSortBy, sortType, setSortType}) {
  const avatar = '/assets/blank_profile.jpg';

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "کاربر": "name",
    "مبلغ": "amount",
    "مرجع": "reference_code",
    "وضعیت": "status",
    "شروع از": "description",
    "زمان": "end_at",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "پروفایل": false,
    "مبلغ": true,
    "مرجع": true,
    "وضعیت": true,
    "شروع از": true,
    "زمان": true,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {paymentReport.map(
          ({id, name, phone, photo, amount, reference_code, status, description, time}, index) => {
            const isLast = index === paymentReport.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    {photo.length > 0 &&
                      <Avatar variant="circular" alt="tania andrew"
                              className="cursor-pointer border-white"
                              withBorder={true} size="sm"
                              src={getFileUrl(photo)}
                      />
                    }
                    {photo.length === 0 &&
                      <Avatar variant="circular" alt="tania andrew"
                              className="cursor-pointer border-white"
                              withBorder={true} size="sm"
                              src={avatar}
                      />
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(amount, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(reference_code)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      variant="ghost"
                      value={status}
                      color={
                        status === "در حال پرداخت" ? "amber" : status === "پرداخت موفق" ? "green" : "red"
                      }
                      icon={
                        status === "در حال پرداخت" ? <BsHourglassSplit/> : status === "پرداخت موفق" ? <BsCheck/> :
                          <BsX/>
                      }
                    />
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      variant="outlined"
                      value={description}
                    />
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(`${time.split(" ")[1]} ${time.split(" ")[0]}`)}
                    </Typography>
                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}